import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';




import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';


const GitaDharaClass3to5 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3to5/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3to5/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3to5/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3to5/4.webp`;

   
    const photos = [
      
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
          {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        }

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               Gita Dhara
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Classes: 3 to 5    Date: 18 December 2025  <br />
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ When knowledge guides Our actions and calmness shapes our mind, We walk the path of righteousness. ”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                National Public School Yeshwanthpur organised three sessions in the Gita Dhara series on Friday, 5, Tuesday, 9 and Thursday, 18 December 2025 for the students of Class 3 to 5 on the teachings of the Bhagavad Gita titled “Gita Dhara.” The session was conducted by Ms Sunita Rajesh to familiarise children with the wisdom of the Bhagavad Gita through age appropriate explanations inspiring stories and practical life applications.  
                                <br></br>
                                During the session students were introduced to key concepts from the Gita including Karma Yoga, Jnana Yoga and the importance of performing one’s duty with sincerity and responsibility. Symbolic storytelling such as The Supreme Gardener helped students understand divine guidance and the removal of negativity. Shloka chanting and interactive discussions further strengthened their understanding.
                                <br></br>
                                The session concluded with active student participation and reflections leaving the children inspired to apply the timeless values of the Bhagavad Gita in their everyday lives. It encouraged mindfulness, discipline, and positive qualities that the Bhagavad Gita beautifully imparts.
                                <br></br>
                                   
                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ When knowledge guides Our actions and calmness shapes our mind, We walk the path of righteousness. ”

                                <br />
                            </Typography>
                            </Box>
                             <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default GitaDharaClass3to5;